const rangeEach = function rangeEach(context, start, options) {
  const fn = options.fn;
  const inverse = options.inverse;
  let buffer = '';
  let ctx;
  const ctxOptions = Object.assign({}, options);
  ctxOptions.data = Object.assign({}, options.hash, options.data);
  let startIndex = 0;

  if (start < 0) {
    startIndex = context.length > Math.abs(start) ? context.length + start : 0;
  }

  if (context && context.length > 0) {
    for (let i = startIndex || 0, j = context.length; i < j; i++) {
      ctx = Object.create(context[i]);

      ctxOptions.data.first = i === 0;
      ctxOptions.data.last = i === j - 1;
      ctxOptions.index = i;

      buffer += fn(ctx, ctxOptions);
    }
  } else {
    buffer = inverse(this);
  }
  return buffer;
};

module.exports = rangeEach;
